import React from 'react';
import CheckboxControl from '../../../components/Fields/CheckboxControl';
import ColorModel from '../../../models/ColorModel';

export interface IProps {
    color: ColorModel,
    isSelected: boolean,
    handleItemClicked: (selectedColor: ColorModel) => void
}

const ItemRevisionMiniCard: React.FC<IProps> = ({ color, isSelected, handleItemClicked }) => {

    var backgroundColor = color.colorCode;
    var borderColor = 'black'

    function ItemClicked() {
        handleItemClicked(color);
    }

    return (
        <a style={{ margin: 15 }} onClick={ItemClicked}>
            <div style={{ width: 162, height: 200, overflow: 'hidden', border: '1px solid ' + borderColor }}>
                <div className="card card-user item-mini" style={{ border: '0px solid red' }} >
                    <div style={{ padding: 5 }}>
                        <div style={{ fontSize: 18 }}>
                            {color.name}
                            <span className="pull-right">
                                <CheckboxControl name='test' value={isSelected} onChange={() => { }} width={20} validationResults={[]} />
                            </span>
                        </div>
                    </div>
                    <div style={{ backgroundColor: backgroundColor, width: 162, height: 224, overflow: 'hidden', border: '1px solid ' + borderColor }}>
                        &nbsp;
                    </div>
                </div>
            </div>
        </a>
    );
}
export default ItemRevisionMiniCard;
